<template>
  <card>
    <list
      v-if="$store.state.user.is_root"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      // modalCreate: "business",
      fields: [
        {
          key: "name",
          label: "Должность",
          type: "field",
          textType: "text",
          isMultiLang: true,
          readonly: false,
        },
      ],
      /** APIs */
      removeLink: `${process.env.HOST_URL}/api/v3/school/positions`,
      cardLink: "item_jobs_positions",
      itemLink: `${process.env.HOST_URL}/api/v3/school/positions`,
      setLink: `${process.env.HOST_URL}/api/v3/school/positions`,
      columns: [
        {
          key: "name",
          title: "Должность",
        },
        {
          remove: true,
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
